<div class="fx-row align-items-center justify-content-between p-16">
  <div class="fx-row fw-wrap align-items-baseline justify-content-start ml-10 gap-5">
    @if (labelKey()) {
      <span class="text bold">{{ labelKey() || '' | translate }}</span>
      <span class="bold">·</span>
    }
    <app-animated-number [value]="count()" [class]="'bold main'"></app-animated-number>
    <span class="text">
      <span class="bold main">
        {{ (count() > 1 ? countLabelKeyPlural() : countLabelKeySingular()) | translate }}
      </span>
      {{ ('UTILS.MATCHING' | translate).toLowerCase() }}
    </span>
  </div>

  <div class="fx-row align-items-center justify-content-end">
    <ng-content select="[filters]"></ng-content>
    @if (showSearch()) {
      <app-input placeholder="{{ searchPlaceholderKey() | translate }}..." type="text" prefix="search"
                 [(value)]="query"
                 style="width:210px;" class="mr-10"></app-input>
    }
    <div class="fx-row gap-10">
      <ng-content select="[primaryAction]"></ng-content>
      <ng-content select="[secondaryAction]"></ng-content>
    </div>
  </div>
</div>

@if (noticeMessage()) {
  <app-notice level="info" [content]="noticeMessage()!" cssClasses="mh-16 mb-16 p-16"></app-notice>
}
